import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActionResponse } from 'src/app/models/action-response';
import { TerminateMultiAssetDueDatesStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/init-step/due-date-step';
import { TerminateMultiAssetAssetStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/terminate-multi-asset-asset-step/terminate-multi-asset-asset-step-info';
import { TerminateMultiAssetCancelDetailsDataV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/terminate-multi-asset-cancel-details-step/terminate-multi-asset-cancel-details-data';
import * as fromTerminateMultiAssetWizard from './reducer';
import { State } from './state';

export const selectTerminateMultiAssetWizardState = createFeatureSelector<State>(
  fromTerminateMultiAssetWizard.terminateMultiAssetWizardFeatureKey,
);

export const selectAssetStep = createSelector(
  selectTerminateMultiAssetWizardState,
  (state: State): TerminateMultiAssetAssetStepV26 => state.assetStep,
);

export const selectDueDateStep = createSelector(
  selectTerminateMultiAssetWizardState,
  (state: State): TerminateMultiAssetDueDatesStepV26 => state.dueDatesStep,
);

export const selectCancelDetailsStep = createSelector(
  selectTerminateMultiAssetWizardState,
  (state: State): TerminateMultiAssetCancelDetailsDataV26[] => state.cancelDetailsStep,
);

export const selectTerminateMultiAssetState = createSelector(
  selectTerminateMultiAssetWizardState,
  (state: State): ActionResponse => state.response,
);

export const selectErrorMessage = createSelector(selectTerminateMultiAssetWizardState, (state: State): string => state.errorMessage);
